import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {
  AangifteSchenkbelasting,
  GiftTaxEntity,
  SbBerekening
} from "@snelstart-ventures/fiscaal/domain-logic";
import {FormBuilder, FormGroup} from "@angular/forms";
import {BokkzAlgDataService, BokkzSbDataService} from "@snelstart-ventures/fiscaal/domain-logic";
import {Subscription} from "rxjs";

@Component({
  selector: 'snelstart-venture-fiscaal-feature-conserverende-aanslag',
  standalone: true,
  imports: [],
  templateUrl: './conserverende-aanslag.component.html',
  styleUrl: './conserverende-aanslag.component.css'
})
export class ConserverendeAanslagComponent implements OnInit, OnDestroy {

  @Input() public id!: string;
  private giftTaxEntitySubscription: Subscription | undefined;
  private sbBerekeningSubscription: Subscription | undefined;
  public giftTaxEntity = {} as GiftTaxEntity;
  public sbAangifte = {} as AangifteSchenkbelasting;
  public sbBerekening = {} as SbBerekening;
  public sbBerekeningFg = {} as FormGroup;
  public focusedElementId: string | null = null;

  constructor(
    public algDataService: BokkzAlgDataService,
    public dataService: BokkzSbDataService,
    private fb: FormBuilder) {
    this.sbBerekeningFg = this.fb.group<SbBerekening>({
      totaalBedragContanten: null as unknown as number,
      totaalBedragEffecten: null as unknown as number,
      totaleWaardeGeschonkenOnroerendeZaken: null as unknown as number,
      totaalGeschonkenOndernemingsVermogen: null as unknown as number,
      totaalVrijgesteldOndernemingsVermogen: null as unknown as number,
      totaleWaardeGeschonkenApv: null as unknown as number,
      totaleWaardeGeschonkenPu: null as unknown as number,
      totaleWaardeGeschonkenRoerendeZaken: null as unknown as number,
      totaleWaardeSchuldigErkenning: null as unknown as number,
      totaleWaardeKwijtscheldingen: null as unknown as number,
      totaleWaardeVruchtgebruik: null as unknown as number,
      totaleWaardeOverigeSchenkingen: null as unknown as number,
      totaleSchenking: null as unknown as number,
      benutteVrijstellingen: null as unknown as number,
      totaleVoorwaardelijkeVrijstelling: null as unknown as number,
      totaleBelastbareSchenking: null as unknown as number,
      verschuldigdeSchenkbelasting: null as unknown as number,
      verrekeningOverdrachtsBelasting: null as unknown as number,
      voorkomingDubbeleBelasting: null as unknown as number,
      teBetalenSchenkbelasting: null as unknown as number,
    })
  }

  ngOnInit(): void {
    this.giftTaxEntitySubscription = this.dataService.giftTaxEntity.subscribe((value)=> {
      this.giftTaxEntity = value;
      this.sbAangifte = value.aangifte!;
    })
    this.sbBerekeningSubscription = this.dataService.sbBerekening.subscribe((value)=> {
      this.sbBerekening = value;
      this.sbBerekeningFg.patchValue(value,{emitEvent: false})
    })
  }

  ngOnDestroy(): void {
    if (this.sbBerekeningSubscription) {
      this.sbBerekeningSubscription.unsubscribe()
    }
    if (this.giftTaxEntitySubscription) {
      this.giftTaxEntitySubscription.unsubscribe()
    }
  }

}

